const PopulerPost = [
  {
    id: 1,
    title: "What is the key difference between ...",
  },
  {
    id: 2,
    title: "What is the key difference between ...",
  },
  {
    id: 3,
    title: "What is the key difference between ...",
  },
  {
    id: 4,
    title: "What is the key difference between ...",
  },
  {
    id: 5,
    title: "What is the key difference between ...",
  },
];

const RecentArticle = [
  {
    id: 1,
    title: "FAQs: Emails",
  },
  {
    id: 2,
    title: "FAQs: Emails",
  },
  {
    id: 3,
    title: "FAQs: Emails",
  },
  {
    id: 4,
    title: "FAQs: Validation Rules",
  },
  {
    id: 5,
    title: "FAQs: General questions on customization",
  },
];

export { PopulerPost, RecentArticle };
